<template>
  <div class="contact">
    <h2>Contact Us</h2>
    <p>We'd love to hear from you! Fill out the form below to get in touch.</p>
    <form @submit.prevent="handleSubmit">
      <div class="form-group">
        <label for="email">Email</label>
        <input
          id="email"
          type="email"
          v-model="form.email"
          :placeholder="placeholders.email"
          @focus="clearPlaceholder('email')"
          @blur="restorePlaceholder('email', 'Enter your email')"
        />
      </div>
      <div class="form-group">
        <label for="subject">Subject</label>
        <input
          id="subject"
          type="text"
          v-model="form.subject"
          :placeholder="placeholders.subject"
          @focus="clearPlaceholder('subject')"
          @blur="restorePlaceholder('subject', 'Enter the subject')"
        />
      </div>
      <div class="form-group">
        <label for="message">Message</label>
        <textarea
          id="message"
          v-model="form.message"
          :placeholder="placeholders.message"
          @focus="clearPlaceholder('message')"
          @blur="restorePlaceholder('message', 'Write your message')"
        ></textarea>
      </div>
      <div class="form-actions">
        <button type="submit" class="btn submit-btn">Submit</button>
        <button type="button" class="btn cancel-btn" @click="handleCancel">
          Cancel
        </button>
      </div>
      <p v-if="feedback" class="feedback">{{ feedback }}</p>
    </form>
  </div>
</template>

<script>
export default {
  name: "ContactForm",
  data() {
    return {
      form: {
        email: "",
        subject: "",
        message: "",
      },
      feedback: "",
      placeholders: {
        email: "Enter your email",
        subject: "Enter the subject",
        message: "Write your message",
      },
    };
  },
  methods: {
    handleSubmit() {
      this.feedback = "Thank you for your feedback!";
      // Clear form fields after submission
      this.form.email = "";
      this.form.subject = "";
      this.form.message = "";
      setTimeout(() => {
        this.feedback = "";
      }, 3000); // Clear feedback after 3 seconds
    },
    handleCancel() {
      this.form.email = "";
      this.form.subject = "";
      this.form.message = "";
    },
    clearPlaceholder(field) {
      this.placeholders[field] = ""; // Clear the placeholder
    },
    restorePlaceholder(field, text) {
      if (!this.form[field]) {
        this.placeholders[field] = text; // Restore the placeholder if the input is empty
      }
    },
  },
};
</script>

<style scoped>
@import "@/styles/components/ContactForm.scss";

.feedback {
  margin-top: 1rem;
  color: var(--primary-color);
  font-size: 1rem;
}
</style>
